import React from 'react'
import Checkbox from 'material-ui/Checkbox';

const FormCheckbox = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) =>
 (<Checkbox label={label}
    checked={input.value ? true : false}
    onCheck={input.onChange}
    {...custom}
    />
 )

export default FormCheckbox


// WEBPACK FOOTER //
// ./src/components/FormCheckBox.js